<template>
  <div>
    <tooltip :content="$t('shared.component.v-copy.copy')" placement="right" trigger="hover">
      <span class="flex copy-row" @click="copy">
        {{ hostNameById }}
        <icon type="md-copy" size="20" />
      </span>
    </tooltip>
  </div>
</template>

<script>
  import flatten from 'lodash-es/flatten';

  export default {
    props: {
      instance_id: {
        type: Number || undefined,
        default: undefined
      },
      regions: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      hostNameById: function () {
        return flatten(this.regions?.map((i) => i.instances)).find((i) => i.id === this.instance_id)?.host;
      }
    },
    methods: {
      copy: function () {
        this.$copyText(this.hostNameById).then(() => {
          this.$noty.success(this.$t('shared.component.noty.text_copied'));
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .callers-collapse {
    display: flex;
    width: 100%;

    &__main {
      flex: auto;
    }

    &__controls {
      margin-left: 15px;
      align-self: center;
    }

    &__controls-icon {
      font-size: 18px;

      &:hover {
        cursor: pointer;
      }
    }

    &__content {
      .callers-collapse__item {
        margin-top: 10px;
      }
    }

    &__item {
      display: flex;
      flex-direction: column;
    }

    &__name {
      color: #a0a0a0;
    }
  }
</style>
